import secureApi from '../../utils/secureApi';

export async function deleteBanner(id: string): Promise<void> {
  const response = await secureApi.post<any>(
    `/api/v1/tournaments/admin/banners/delete?_id=${id}`
  );
  
  // Handle API response structure: may be wrapped in { statusCode, data: {...} } or direct
  return (response as any)?.data || response;
} 